<template>
    <div class="tsa-dialogV2" v-show="visible">
        <div class="mask"></div>
        <div class="content" :style="{width: width + 'px', }">
            <div class="tsa-dialogV2-title">
                <h3 v-html="title"></h3>
                <p class="el-icon-close" @click="close"></p>
            </div>
            <div class="tsa-dialogV2-content">
                <slot></slot>
            </div>
            <div class="tsa-dialogV2-btnGroup">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '标题'
        },
        width: {
            type: Number,
            default: 400
        }
    },
    data () {
        return {
            show: false
        }
    },
    methods: {
        close () {
            this.$emit('update:visible', false)
        },
    }
}
</script>

<style lang="scss" scoped>
    .tsa-dialogV2 {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .5);
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: max-content;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 6px;
            padding: 24px 22px 24px 24px;
            box-sizing: border-box;
            .tsa-dialogV2-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 24px;
                h3 {
                    font-weight: bold;
                    font-size: 16px;
                    color: #151B26;
                }
                p {
                    font-size: 16px;
                    color: #8E9095;
                    cursor: pointer;
                    &:hover {
                        color: #2468F2;
                    }
                }
            }
            .tsa-dialogV2-btnGroup {
                width: 100%;
                :deep(.btnGroup) {
                    display: flex;
                    justify-content: flex-end;
                    .tsa-button+.tsa-button {
                        margin-left: 12px;
                    }
                }
            }
        }
    }
</style>